import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { OrgProvider } from '~/contexts/org-context'
import { useAuthContext } from '~/contexts/auth-context'
import { LogtoScopes } from '~/lib/logto/logto'
import { useAuthScopes } from '~/hooks/use-auth-scopes'
import { PagePermissionError } from '~/components/PagePermissionError'
import { useAbodemineFullScreenLoader } from '~/components/brand/abodemine-loader'
import { useEffect } from 'react'
import { AppNavigation } from '~/components/app/shared/navigation/app-navigation'
import { useDynamicConfig } from '~/lib/queries/meta'
import { setAdminMode } from '~/lib/admin-mode'

export const Route = createFileRoute('/admin')({
  beforeLoad: () => {
    if (typeof window !== 'undefined') {
      setAdminMode(true)
    }
  },
  component: AdminLayout,
})

function AdminLayout() {
  const { isAuthenticated, isLoading } = useAuthContext()
  const hasRequiredViewScopes = useAuthScopes(LogtoScopes.AdminAccess)

  // Client-side protection - only redirect after auth state is loaded
  useEffect(() => {
    if (!isLoading && !isAuthenticated && typeof window !== 'undefined') {
      window.location.href = '/'
    }
  }, [isLoading, isAuthenticated])

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex flex-1 items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading...</p>
          </div>
        </div>
      )
    }

    if (!hasRequiredViewScopes) {
      return <PagePermissionError />
    }

    return <Outlet />
  }

  return (
    <div className="flex h-screen flex-col">
      {isLoading ? null : <AppNavigation />}
      <main className="flex-1 overflow-auto">
        {renderContent()}
      </main>
    </div>
  )
} 
